<template>
  <div class="app-root">

    <!-- ═══ 顶部栏 ═══ -->
    <header class="topbar">
      <div class="tb-left">
        <div class="tb-logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 2L2 7l10 5 10-5-10-7z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
          </svg>
        </div>
        <span class="tb-brand">化工小助手</span>
      </div>

      <div class="tb-center">
        <VisitorCounter :count="visitorCount" :animate="true" />
      </div>

      <div class="tb-right">
        <a href="https://www.bilibili.com/video/BV1oSDSBfERS/" target="_blank" class="btn-bilibili">
          <svg viewBox="0 0 24 24" fill="currentColor" style="width:18px;height:18px">
            <path d="M17.813 4.653h.854c1.51.054 2.769.578 3.773 1.574 1.004.995 1.524 2.249 1.56 3.76v7.36c-.036 1.51-.556 2.769-1.56 3.773s-2.262 1.524-3.773 1.56H5.333c-1.51-.036-2.769-.556-3.773-1.56S.036 18.858 0 17.347v-7.36c.036-1.511.556-2.765 1.56-3.76 1.004-.996 2.262-1.52 3.773-1.574h.774l-1.174-1.12a1.234 1.234 0 0 1-.373-.906c0-.356.124-.658.373-.907l.027-.027c.267-.249.573-.373.92-.373.347 0 .653.124.92.373L9.653 4.44c.071.071.134.142.187.213h4.267a.836.836 0 0 1 .16-.213l2.853-2.747c.267-.249.573-.373.92-.373.347 0 .662.151.929.4.267.249.391.551.391.907 0 .355-.124.657-.373.906zM5.333 7.24c-.746.018-1.373.276-1.88.773-.506.498-.769 1.13-.786 1.894v7.52c.017.764.28 1.395.786 1.893.507.498 1.134.756 1.88.773h13.334c.746-.017 1.373-.275 1.88-.773.506-.498.769-1.129.786-1.893v-7.52c-.017-.765-.28-1.396-.786-1.894-.507-.497-1.134-.755-1.88-.773zM8 11.107c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c0-.373.129-.689.386-.947.258-.257.574-.386.947-.386zm8 0c.373 0 .684.124.933.373.25.249.383.569.4.96v1.173c-.017.391-.15.711-.4.96-.249.25-.56.374-.933.374s-.684-.125-.933-.374c-.25-.249-.383-.569-.4-.96V12.44c.017-.391.15-.711.4-.96.249-.249.56-.373.933-.373z"/>
          </svg>
          <span>B站：化工小助手</span>
        </a>

        <div class="contact-wrap"
             @mouseenter="showQr = true"
             @mouseleave="showQr = false"
             @click="showQr = !showQr">
          <button class="btn-contact">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
            </svg>
            联系我
          </button>
          <Transition name="qr-fade">
            <div v-if="showQr" class="qr-popup">
              <div class="qr-arrow"></div>
              <img :src="'/qq.JPG'" alt="联系方式" class="qr-img"/>
              <p class="qr-hint">扫码添加我QQ</p>
            </div>
          </Transition>
        </div>

        <button class="btn-dl-topbar" @click="handleDownload">
          <svg viewBox="0 0 20 20" fill="currentColor" style="width:16px;height:16px">
            <path fill-rule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd"/>
          </svg>
          下载客户端
        </button>
      </div>
    </header>

    <!-- ═══ 主体 ═══ -->
    <div class="app-body">

      <!-- 左侧导航 -->
      <nav class="sidebar" :class="{ collapsed: sidebarCollapsed }">
        <div class="sb-group-label">功能模块</div>
        <button
          v-for="item in navItems"
          :key="item.key"
          class="sb-item"
          :class="{ active: activeNav === item.key, locked: item.locked }"
          @click="!item.locked && switchNav(item.key)"
        >
          <div class="sb-icon" v-html="item.icon"></div>
          <span class="sb-label">{{ item.label }}</span>
          <span v-if="item.locked" class="sb-badge">待开发</span>
        </button>

        <div class="sb-spacer"></div>
        <div class="sb-bottom">
          <div class="sb-ver">v1.0.0</div>
        </div>
      </nav>

      <!-- 收起按钮 -->
      <button class="sidebar-toggle" @click="sidebarCollapsed = !sidebarCollapsed">
        <svg viewBox="0 0 20 20" fill="currentColor"
             :style="{ transform: sidebarCollapsed ? 'rotate(180deg)' : 'none' }">
          <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
        </svg>
      </button>

      <!-- 右侧内容 -->
      <main class="content">
        <BalanceModule
          v-if="activeNav === 'balance'"
          @download="handleDownload"
          @learnMore="showLearnMore"
        />
        <OptimizeModule
          v-else-if="activeNav === 'optimize'"
          @notifyMe="showNotifyDialog"
        />
        <EquipmentModule
          v-else-if="activeNav === 'equipment'"
          @notify="showNotifyDialog"
        />
        <PipelineModule
          v-else-if="activeNav === 'pipeline'"
          @download="handleDownload"
        />
        <PumpModule
          v-else-if="activeNav === 'pump'"
          @download="handleDownload"
        />
        <BalanceModule
          v-else-if="activeNav === 'balance'"
          @download="handleDownload"
        />
      </main>
    </div>

    <footer class="site-footer">
      <div class="icp-link">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">冀ICP备2025113994号-2</a>
      </div>
      <span>&copy; 2026 化工小助手</span>
    </footer>

  </div>
</template>

<script setup>
import { ref } from 'vue'
import VisitorCounter from '../components/VisitorCounter/VisitorCounter.vue'
import BalanceModule from './modules/balance/BalanceModule.vue'
import OptimizeModule from './modules/optimize/OptimizeModule.vue'
import EquipmentModule from './modules/equipment/EquipmentModule.vue'
import PipelineModule from './modules/pipeline/PipelineModule.vue'
import PumpModule from './modules/pump/PumpModule.vue'
import { useVisitorCount } from '../components/VisitorCounter/useVisitorCount.js'

const { count: visitorCount } = useVisitorCount()

const navItems = [
  {
    key: 'balance',
    label: 'Aspen 衡算',
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>',
    locked: false,
  },
  {
    key: 'pump',
    label: '泵选型',
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4"/></svg>',
    locked: false,
  },
  {
    key: 'pipeline',
    label: '管道选型',
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 12h16M4 8h16M4 16h16"/></svg>',
    locked: false,
  },
  {
    key: 'optimize',
    label: '多目标优化',
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06A1.65 1.65 0 0015 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.6 15a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9"/></svg>',
    locked: true,
  },
  {
    key: 'equipment',
    label: '设备选型',
    icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M4 12h16M12 4v16"/></svg>',
    locked: true,
  },
]

const activeNav = ref('balance')
const showQr = ref(false)
const sidebarCollapsed = ref(false)

function switchNav(key) { activeNav.value = key }

function handleDownload() {
  window.location.href = '/api/download'
}

function showLearnMore() {
  alert('更多详细文档即将上线，敬请期待！')
}

function showNotifyDialog() {
  alert('已订阅上线通知，我们会在功能上线时第一时间通知您！')
}
</script>

<style scoped>
/* ═══ Root ═══ */
.app-root {
  --blue:       #4285f4;
  --blue-dark:  #1a73e8;
  --green:      #34a853;
  --yellow:     #fbbc04;
  --red:        #ea4335;
  --bg:         #ffffff;
  --bg-warm:    #f8f9fa;
  --sidebar-bg:  #f1f3f4;
  --surface:     #ffffff;
  --text:        #202124;
  --text-2:      #5f6368;
  --text-3:      #80868b;
  --border:      #dadce0;
  --border-lt:   #e8eaed;

  font-family: 'PingFang SC','Microsoft YaHei','Noto Sans SC',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
  color: var(--text);
  background: var(--bg);
  height: 100vh;
  display: flex; flex-direction: column;
  overflow: hidden;
}

/* ═══ Topbar ═══ */
.topbar {
  height: 64px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-lt);
  background: var(--surface); z-index: 100;
}
.tb-left { display: flex; align-items: center; gap: 10px; }
.tb-logo { width: 28px; height: 28px; color: var(--blue); }
.tb-logo svg { width: 100%; height: 100%; }
.tb-brand { font-size: 17px; font-weight: 700; letter-spacing: -.01em; }

.tb-center {
  position: absolute;
  left: 50%; transform: translateX(-50%);
}

.tb-right { display: flex; align-items: center; gap: 10px; }

.btn-bilibili {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 16px; border-radius: 20px; border: 1px solid var(--border);
  background: #fff; color: #00a1d6; font-size: 13px; font-weight: 600;
  cursor: pointer; transition: all .2s; font-family: inherit; text-decoration: none;
}
.btn-bilibili:hover {
  background: #00a1d6; color: #fff; border-color: #00a1d6;
  transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,161,214,.35);
}

.contact-wrap { position: relative; }
.btn-contact {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 18px; border-radius: 20px; border: 1px solid var(--border);
  background: transparent; color: var(--text); font-size: 13px; font-weight: 600;
  cursor: pointer; transition: all .2s; font-family: inherit;
}
.btn-contact:hover { background: var(--bg-warm); border-color: var(--text-3); }
.btn-contact svg { width: 17px; height: 17px; }

.qr-popup {
  position: absolute; top: calc(100% + 12px); right: 0;
  z-index: 200; background: #fff;
  padding: 16px 16px 12px; border-radius: 14px;
  box-shadow: 0 8px 32px rgba(60,64,67,.22), 0 1px 4px rgba(60,64,67,.15);
  border: 1px solid var(--border-lt); text-align: center; min-width: 180px;
}
.qr-arrow {
  position: absolute; top: -6px; right: 28px;
  width: 12px; height: 12px; background: #fff;
  border-left: 1px solid var(--border-lt); border-top: 1px solid var(--border-lt);
  transform: rotate(45deg);
}
.qr-img { width: 330px; height: auto; border-radius: 8px; display: block; }
.qr-hint { margin: 8px 0 0; font-size: 12px; color: var(--text-3); }

.qr-fade-enter-active { transition: opacity .2s ease, transform .2s ease; }
.qr-fade-leave-active { transition: opacity .15s ease, transform .15s ease; }
.qr-fade-enter-from { opacity: 0; transform: translateY(-6px) scale(.96); }
.qr-fade-leave-to   { opacity: 0; transform: translateY(-4px) scale(.98); }

.btn-dl-topbar {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 20px; border-radius: 20px; border: 1px solid var(--border);
  background: var(--blue); color: #fff; font-size: 13px; font-weight: 600;
  cursor: pointer; transition: all .2s; font-family: inherit;
}
.btn-dl-topbar:hover {
  background: var(--blue-dark); transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66,133,244,.35);
}

/* ═══ Body ═══ */
.app-body { flex: 1; display: flex; overflow: hidden; position: relative; }

/* ═══ Sidebar ═══ */
.sidebar {
  width: 216px; flex-shrink: 0;
  background: var(--sidebar-bg);
  border-right: 1px solid var(--border-lt);
  display: flex; flex-direction: column;
  padding: 16px 0;
  transition: width .28s cubic-bezier(.4,0,.2,1);
  overflow: hidden;
}
.sidebar.collapsed { width: 0; }

.sb-group-label {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .08em; color: var(--text-3);
  padding: 0 20px 8px; white-space: nowrap;
}

.sb-item {
  display: flex; align-items: center; gap: 10px;
  margin: 2px 8px; padding: 10px 14px; border-radius: 10px;
  border: none; background: transparent;
  cursor: pointer; font-size: 14px; font-family: inherit;
  color: var(--text-2); transition: all .15s;
  position: relative; overflow: hidden; white-space: nowrap;
}
.sidebar.collapsed .sb-item { padding: 10px 0; margin: 2px 8px; justify-content: center; }
.sb-item svg, .sb-item :deep(svg) { width: 20px; height: 20px; flex-shrink: 0; opacity: .7; }
.sb-item:hover:not(.locked):not(.active) { background: rgba(0,0,0,.04); }
.sb-item.active { background: #e8f0fe; color: var(--blue-dark); font-weight: 600; }
.sb-item.active svg, .sb-item.active :deep(svg) { opacity: 1; color: var(--blue); }
.sb-item.locked { opacity: .55; cursor: not-allowed; }

.sb-badge {
  margin-left: auto; font-size: 10px; font-weight: 700;
  padding: 2px 8px; border-radius: 6px;
  background: #fef7e0; color: #b06000; flex-shrink: 0;
}
.sidebar.collapsed .sb-badge,
.sidebar.collapsed .sb-label,
.sidebar.collapsed .sb-group-label { display: none; }

.sb-spacer { flex: 1; }
.sb-bottom { padding: 16px 20px; }
.sidebar.collapsed .sb-bottom { padding: 16px 0; }
.sb-ver { font-size: 11px; color: var(--text-3); }

/* 收起按钮 */
.sidebar-toggle {
  position: absolute; top: 50%; left: 216px;
  transform: translateY(-50%);
  width: 18px; height: 48px;
  background: var(--surface); border: 1px solid var(--border);
  border-left: none; border-radius: 0 8px 8px 0;
  cursor: pointer; z-index: 20;
  display: flex; align-items: center; justify-content: center;
  transition: left .28s cubic-bezier(.4,0,.2,1), background .15s;
  box-shadow: 2px 0 8px rgba(0,0,0,.06);
}
.sidebar-toggle:hover { background: var(--bg-warm); border-color: var(--text-3); }
.sidebar-toggle svg { width: 14px; height: 14px; color: var(--text-3); }
.sidebar.collapsed ~ .sidebar-toggle { left: 0; }
.sidebar-toggle:hover svg { color: var(--text); }

/* ═══ Content ═══ */
.content { flex: 1; overflow-y: auto; background: var(--bg); }

/* ═══ Footer ═══ */
.site-footer {
  flex-shrink: 0; text-align: center; padding: 12px;
  font-size: 12px; color: var(--text-3);
  border-top: 1px solid var(--border-lt); background: var(--surface);
  display: flex; flex-direction: column; align-items: center; gap: 4px;
}

.icp-link a {
  color: var(--text-3);
  text-decoration: none;
  transition: color .15s;
}
.icp-link a:hover { color: var(--blue-dark); text-decoration: underline; }

/* ═══ Responsive ═══ */
@media (max-width: 1024px) {
  .tb-center { position: static; transform: none; margin: 0 16px; }
}
@media (max-width: 768px) {
  .tb-center { display: none; }
  .sidebar { width: 0; overflow: hidden; }
  .sidebar-toggle { left: 0 !important; }
  .btn-bilibili span { display: none; }
  .btn-bilibili { padding: 8px; }
  .btn-dl-topbar span { display: none; }
  .btn-dl-topbar { padding: 8px 12px; }
}
</style>
